import type { IMerchantDocumentProps } from '@/data/landing/MerchantDocument'
import type { FC } from 'react'

const MerchantDocumentCard: FC<IMerchantDocumentProps> = ({
  title,
  subtitle,
  icon
}) => {
  return (
    <div className="flex shrink-0 flex-col items-center justify-end pt-6 mobile:pt-8">
      <div className="relative z-10 flex items-center justify-center rounded-[22px] bg-primary-50 p-3 shadow-sm ring-1 ring-primary-100 mobile:rounded-[28px] mobile:p-5">
        {icon}
      </div>

      <div className="-mt-6 flex h-28 w-[170px] flex-col items-center justify-center rounded-[22px] border border-primary-100 bg-white px-3 pb-4 pt-8 text-center shadow-[0_14px_30px_rgba(14,116,144,0.08)] mobile:h-32 mobile:w-[220px] mobile:rounded-[28px] mobile:px-4 mobile:pb-5 mobile:pt-10">
        <p className="text-xs font-bold leading-5 text-slate-900 mobile:text-sm mobile:leading-7">
          {title}
        </p>
        {!!subtitle && (
          <p className="text-[10px] leading-5 text-slate-500 mobile:text-xs mobile:leading-6">
            {subtitle}
          </p>
        )}
      </div>
    </div>
  )
}

export default MerchantDocumentCard
